import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const CarriersChart = ({ data }) => {
	const { t } = useTranslation();
	const dataCopy = [...data];
	const sortedData = dataCopy.length
		? dataCopy.sort((a, b) => b.jobs - a.jobs)
		: [];
	const highestValue = sortedData.length && sortedData[0].jobs;

	return (
		<Box>
			<Box
				sx={{ background: "#000", color: "#fff", mb: "18px", p: "6px 14px" }}
			>
				{t("sale_label")} &mdash; {t("top_n_carriers", { value: 50 })}
			</Box>
			{sortedData.length ? (
				<Box
					sx={{ maxHeight: "416px", overflowY: "scroll", paddingRight: "30px" }}
				>
					<Row>
						<SmallCell>{t("ordinal_number_short")}</SmallCell>
						<SmallCell>{t("country")}</SmallCell>
						<TitleCell>{t("nip_label")}</TitleCell>
						<TitleCell>{t("orders")}</TitleCell>
					</Row>
					{sortedData.map((d, index) => {
						return (
							<Row key={`chart-carriers-row-${index}`}>
								<SmallCell>{index + 1}</SmallCell>
								<SmallCell>{d.country}</SmallCell>
								<MarginCell>{d.nip}</MarginCell>
								<ValueCell value={d.jobs} highestValue={highestValue} />
							</Row>
						);
					})}
				</Box>
			) : (
				<Box sx={{ textAlign: "center", mt: "20px;" }}>{t("no_sales")}</Box>
			)}
		</Box>
	);
};

export default CarriersChart;

const Row = (props) => <Box sx={{ display: "flex" }}>{props.children}</Box>;

const SmallCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 20%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const TitleCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 30%", p: "0 2px" }}>
		{props.children}
	</Box>
);

const ValueCell = ({ value, highestValue }) => (
	<Box
		sx={{
			border: "1px solid #BFBFBF",
			flex: "0 0 30%",
			color: "#000",
			position: "relative",
			"&:before": {
				content: "''",
				position: "absolute",
				left: 0,
				top: 0,
				background: "#FF555Acc",
				height: "100%",
				width: `calc(${value} * 100% / ${highestValue})`,
				zIndex: "1",
			},
		}}
	>
		<Box sx={{ position: "relative", zIndex: "100", p: "0 2px" }}>{value}</Box>
	</Box>
);

const MarginCell = (props) => (
	<Box sx={{ border: "1px solid #BFBFBF", flex: "0 0 30%", p: "0 2px" }}>
		{props.children}
	</Box>
);
